const MouseActionTypes = {
    UPDATE_MOUSE_POS : 'UPDATE_MOUSE_POS',
    STORE_MOUSE_REF : 'STORE_MOUSE_REF',
}

export default MouseActionTypes